import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4faf5858"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  style: {"padding-right":"9px","padding-left":"9px"},
  class: "row"
}
const _hoisted_3 = { class: "col-12 d-flex justify-content-end" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Create your investment opportunity")
const _hoisted_5 = { class: "row m-3 gx-5 gy-xl-5 gy-3" }
const _hoisted_6 = {
  class: "content rounded-3",
  style: {"background-color":"#1b283f"}
}
const _hoisted_7 = { class: "row px-2 py-3" }
const _hoisted_8 = { class: "col-sm-4 col-12 text-center my-auto" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "col-sm-8 col-12 text-white text-center my-sm-auto mt-3 pe-md-4" }
const _hoisted_11 = {
  class: "text-sm-start",
  style: {"color":"white !important","font-size":"1.35rem","font-weight":"600","line-height":"1.2","height":"50px"}
}
const _hoisted_12 = {
  style: {"font-size":"13px !important","font-weight":"400","margin-right":"6px !important","height":"61px","margin-top":"0px !important","margin-left":"0px !important","margin-bottom":"0px !important"},
  class: "overflow-hidden text-sm-start mx-sm-0 mx-5 resp-height"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "/create-investment-opportunity",
          class: "btn btn-primary mx-3 res-width"
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.businesses.founderBusinesses, (business) => {
        return (_openBlock(), _createBlock(_component_router_link, {
          to: `/business/${business.id}`,
          class: "col-xl-6 col-lg-12 col-12",
          key: business.id
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", null, [
                    _createElementVNode("img", {
                      class: "my-2",
                      src: `${business.logo ?? '/media/avatars/blank.png'}`,
                      style: {"width":"120px","height":"128px","object-fit":"cover","border-radius":"0.775rem !important"}
                    }, null, 8, _hoisted_9)
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("h3", _hoisted_11, _toDisplayString(_ctx.truncateText(business.name, 50)), 1),
                  _createElementVNode("p", _hoisted_12, _toDisplayString(business.summary), 1)
                ])
              ])
            ])
          ]),
          _: 2
        }, 1032, ["to"]))
      }), 128))
    ])
  ]))
}